import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { pathfinderDebugOpenAtom } from '@root/features/trade/swap/atoms/reatom-pathfinder-debug'

export const PathfinderDebugButton: React.FC = () => {
  const [, setOpen] = useAtom(pathfinderDebugOpenAtom)
  return (
    <Root
      type="button"
      onClick={() => setOpen(true)}
      title="pathfinder dev probe"
    >
      pf
    </Root>
  )
}

const Root = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;
  padding: 0;

  background: transparent;
  border: 1px dashed var(--yellow-9, #eab308);
  border-radius: 4px;
  color: var(--yellow-9, #eab308);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  cursor: pointer;

  &:hover {
    background: var(--yellow-9, #eab308);
    color: var(--appearance-1);
  }
`
